import { useHistorySections } from '@src/packages/dashboard/components/ReportSummary/hooks/useHistorySections';
import type { HistorySectionState } from '@src/packages/dashboard/components/ReportSummary/hooks/useHistorySections';
import type {
  ExecutionsHistoryScheduleQuery,
  ExecutionsHistoryScheduleSection,
} from '@src/models/interfaces/executionsHistoryDashboard.interface';
import ExecutionsHistoryDashboardService from '@src/services/ExecutionsHistoryDashboardService';

export const SCHEDULE_HISTORY_SECTIONS: ExecutionsHistoryScheduleSection[] = [
  'schedule-overview',
  'schedule-compliance',
  'schedule-events',
  'schedule-users',
  'schedule-divisions',
];

export type ScheduleHistorySectionState = HistorySectionState;
export type ScheduleSectionsState = Record<ExecutionsHistoryScheduleSection, ScheduleHistorySectionState>;

const scheduleSectionQueryKey = (
  section: ExecutionsHistoryScheduleSection,
  query: ExecutionsHistoryScheduleQuery,
) =>
  JSON.stringify(
    section === 'schedule-overview'
      ? query
      : {
          organizationId: query.organizationId,
          divisionIds: query.divisionIds,
          scheduleIds: query.scheduleIds,
          range: query.range,
        },
  );

const loadScheduleSection = (
  service: ExecutionsHistoryDashboardService,
  section: ExecutionsHistoryScheduleSection,
  query: ExecutionsHistoryScheduleQuery,
) => service.getScheduleSection(section, query);

/** Loads schedule report sections independently, matching the Tasks report loading/retry pattern. */
export const useScheduleHistorySections = (query?: ExecutionsHistoryScheduleQuery) =>
  useHistorySections<ExecutionsHistoryScheduleQuery, ExecutionsHistoryScheduleSection>(query, {
    sections: SCHEDULE_HISTORY_SECTIONS,
    queryKey: scheduleSectionQueryKey,
    loadSection: loadScheduleSection,
  });

export type ScheduleHistorySectionsController = ReturnType<typeof useScheduleHistorySections>;
